import { ReactNode } from 'react';
import { ActionButtonV2, type LineIconData } from '../action-button-v2';
import { Button } from '@/components/ui/button';
import { FormMode } from '@/types/form';
import { cn } from '@/lib/utils';

interface HeaderSourceActionV2 {
  label: string;
  onClick: () => void;
  icon?: LineIconData;
}

export interface FormHeaderActionsV2Props {
  mode: FormMode;
  source?: HeaderSourceActionV2;
  info?: ReactNode;
  className?: string;
  sourceClassName?: string;
}

export const FormHeaderActionsV2 = ({ mode, source, info, className, sourceClassName }: FormHeaderActionsV2Props) => {
  const showSource = mode !== 'view' && source;
  const showInfo = mode !== 'add' && info;

  if (!showSource && !showInfo) {
    return null;
  }

  return (
    <div className={cn('flex items-center gap-2 bg-muted px-3', className)}>
      {showSource &&
        (source.icon ? (
          <ActionButtonV2 icon={source.icon} title={source.label} onClick={source.onClick} />
        ) : (
          <Button
            onClick={source.onClick}
            title={source.label}
            size='sm'
            type='button'
            className={cn(
              'flex h-8 items-center justify-center rounded bg-main/85 px-4 text-[13px] font-semibold text-white shadow-sm transition-colors hover:bg-main',
              sourceClassName
            )}
          >
            {source.label}
          </Button>
        ))}
      {showInfo}
    </div>
  );
};

export default FormHeaderActionsV2;
